
<nav class="fixed top-0 z-50 w-full bg-white border-b border-gray-200 dark:bg-gray-800 dark:border-gray-700">
    <div class="w-full flex flex-wrap items-center justify-between mx-auto p-3 sm:p-4 gap-y-2">
    <a class="flex items-center space-x-2 md:space-x-3 rtl:space-x-reverse">
        <img src="assets/images/logo.png" class="w-6 h-6 sm:w-8 sm:h-8" alt="Flowbite Logo" />
        <span class="self-center text-base sm:text-2xl font-semibold whitespace-nowrap">AOC</span>
    </a>
    <div class="flex items-center md:order-2 space-x-1 md:space-x-3 rtl:space-x-reverse">
      <div class="inline-flex items-center cursor-pointer">
        <button class="py-1 px-2 font-medium text-gray-500 bg-gray-100 rounded-full border flex gap-1">
            <!-- Green-to-white Gradient Circle Icon -->
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="gray" class="size-6">
                <defs>
                    <linearGradient id="greenWhiteGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" style="stop-color:rgb(104, 121, 82);stop-opacity:1" />   <!-- local-color-1 -->
                        <stop offset="100%" style="stop-color:rgb(188, 202, 169);stop-opacity:1" /> <!-- local-color-5 -->
                    </linearGradient>
                </defs>
                <circle cx="12" cy="12" r="10" stroke="gray" stroke-width="1.5" fill="url(#greenWhiteGradient)"/>
            </svg>
            
            <!-- Display the sliced address -->
            {{ sliceAddress(listenWalletAddress()) }}
            <svg (click)="copyAddress(listenWalletAddress())" class="w-6 h-6 text-gray-500 dark:text-white cursor-pointer" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
              <path stroke="currentColor" stroke-linejoin="round" stroke-width="2" d="M9 8v3a1 1 0 0 1-1 1H5m11 4h2a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-7a1 1 0 0 0-1 1v1m4 3v10a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-7.13a1 1 0 0 1 .24-.65L7.7 8.35A1 1 0 0 1 8.46 8H13a1 1 0 0 1 1 1Z"/>
          </svg>
        </button>
        
    </div>    
      <!-- <div class="inline-flex items-center cursor-pointer">
        <w3m-button balance='hide' />
      </div> -->
      <label class="inline-flex items-start md:items-center flex-col-reverse md:flex-row me-2 md:me-3 cursor-pointer">
        <!-- Bind to the toggle change event -->
        <input type="checkbox" value="" class="sr-only peer" [checked]="isChecked" (change)="onDistributionModeChange()">
        <div class="relative me-2 w-11 h-6 bg-gray-200 rounded-full peer dark:bg-gray-700 peer-focus:ring-4 peer-focus:ring-transparent dark:peer-focus:ring-transparent peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-yellow-400"></div>
        <!-- Bind label text dynamically -->
        <span class=" md:me-3 text-xs sm:text-sm font-medium text-gray-900 dark:text-gray-300">{{ distributionMode }} Distribution</span>
      </label>
      <button type="button" class="flex text-sm bg-gray-800 rounded-full md:me-0 focus:ring-4 focus:ring-gray-300" id="user-menu-button" aria-expanded="false" data-dropdown-toggle="user-dropdown" data-dropdown-placement="bottom">
        <span class="sr-only">Open user menu</span>
        <img class="w-6 h-6 sm:w-8 sm:h-8 rounded-full" src="assets/images/logo.png" alt="user photo">
      </button>
      <!-- Dropdown menu -->
      <div class="z-50 hidden my-4 text-base list-none bg-white divide-y divide-gray-100 rounded-lg shadow" id="user-dropdown">
        <ul aria-labelledby="user-menu-button">
          <!-- <li>
            <a href="#" class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
              <path stroke-linecap="round" stroke-linejoin="round" d="M17.982 18.725A7.488 7.488 0 0 0 12 15.75a7.488 7.488 0 0 0-5.982 2.975m11.963 0a9 9 0 1 0-11.963 0m11.963 0A8.966 8.966 0 0 1 12 21a8.966 8.966 0 0 1-5.982-2.275M15 9.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
            </svg>Profile
            </a>
          </li> -->                
          <li>
            <a (click)="disconnectMetamask()" class="px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center cursor-pointer rounded-lg">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 9V5.25A2.25 2.25 0 0 1 10.5 3h6a2.25 2.25 0 0 1 2.25 2.25v13.5A2.25 2.25 0 0 1 16.5 21h-6a2.25 2.25 0 0 1-2.25-2.25V15m-3 0-3-3m0 0 3-3m-3 3H15" />
              </svg>
              Sign out</a>
          </li>
        </ul>
      </div>
    </div>
    </div>
</nav>
  
